<template>
  <div class="drawer" v-if="curUser">
    <div class="user-avatar">
      <!--      <div class="avatar"></div>-->
      <div v-if="curUser" class="avatar-details">
        <h5>{{ curUser.Username }}</h5>
        <p>{{ curUser.Type }}</p>
        <p>{{ defaultStore }}</p>
      </div>
    </div>
    <div class="routes">
      <ul>
        <li v-if="isUpdateAvailable">
          <a @click="updateApp">
            <div class="icon-box">
              <font-awesome-icon class="icon text-info" icon="fa-solid fa-exclamation-circle"/>
            </div>
            <div class="d-flex flex-column text-center">
              Update Is Available
              <span class="text-sm" @click="updateApp">Click to Update</span>
            </div>
          </a>
        </li>
        <li >
          <router-link @click.native="back" :to="{ name : 'pos' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-basket-shopping"/>
            </div>
            Sales
          </router-link>
        </li>

        <li>
          <router-link @click.native="back" :to="{ name : 'salesRecords' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-receipt"/>
            </div>
            Order History
          </router-link>
        </li>

        <li :class="setClass">
          <router-link @click.native="back" :to="{name : 'settings'}">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-gear"/>
            </div>
            Settings

          </router-link>
        </li>
        <li>
          <a @click="logout">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-arrow-right-from-bracket"/>
            </div>
            Log out
          </a>
        </li>

      </ul>
      <br>
      <div class="last-upd">
        Last Updated : {{ lastUpdated }}
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "NavigationDrawer",
  props: {
    close: {
      type: Function,
      required: true,
    }
  },
  beforeMount() {
    this.validateLogin();
    auth.isStoreSelected();
  },
  computed: {
    defaultStore() {
      return this.$store.getters.getDefaultStore.StoreName
    },
    lastUpdated() {
      return this.$store.getters.getLasUpdated
    },
    curUser() {
      return this.$store.getters.getCurrentUser
    },
    isUpdateAvailable() {
      // return true;
      return this.$store.getters.getUpdateAvailability;
    },
    setClass() {
      return this.curUser.Type.toLowerCase() === 'admin' ? '' : 'disabled'
    },
    setMsg() {
      return this.curUser.Type === 'admin' ? '' : 'blocked'
    },
  },
  methods: {
    updateApp() {
      this.$store.commit(`setUpdateAvailability`, false);
      return window.location.reload(true);
    },
    async validateLogin() {
      let isLoggedIn = await auth.isCashierLoggedIn();
      if (!isLoggedIn) {
        return this.$router.push({name: 'poslogin'})
      }
    },
    async logout() {
      let user = this.curUser.Username;
      if (user === 'Admin') {
        user = localStorage.getItem("supportAgent");
        localStorage.removeItem(`supportAgent`);
      }
      this.$store.dispatch(`recordLogout`,user)
      this.$router.push({name: 'poslogin'})
      this.back();
    },
    back() {
      if (this.close) {
        this.close();
      } else {
        console.log("Close not defined")
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  display: none;
}

.drawer {
  width: 100%;
  background: white;
  height: 100%;
  overflow-y: auto;

  .routes {
    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        padding: 0;

        a {
          height: 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
          font-weight: 600;
          padding-left: 10px;
          text-decoration: none;
          color: #1c1c1c;

          .icon-box {
            width: 35px;
            margin-right: 10px;
            display: flex;
            justify-content: center;

            .icon {
              font-size: 25px;
              color: #34373C;
            }
          }

          &:hover, &.router-link-exact-active {
            background: #f1f1f1;
            color: #42b983;
            font-weight: 700;

            .icon-box {
              .icon {
                color: #42b983;
              }
            }
          }
        }
      }
    }
  }

  .user-avatar {
    display: inline-flex;
    width: 100%;
    background: url('/src/assets/img/KazangBanner.png') fixed;
    background-size: cover;
    color: white;
    min-height: 140px;
    background-color: rgba(50, 70, 80, 0.7);
    background-blend-mode: soft-light;

    .avatar {
      background: #40434A;
      min-width: 80px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }

    .avatar-details {
      width: 100%;
      padding: 5px 5px 5px 10px;
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;

      h5, p {
        margin: 0;
      }

      p {
        font-size: 15px;
        color: #ffffff;
        font-weight: 400;

        &:nth-child(3) {
          color: #9ccc65;
          font-weight: 600;
        }
      }

    }
  }
}

ul {
  text-align: center;

  span {
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: bold;
  }
}

.last-upd {
  font-weight: bold;
}
</style>
